import * as React from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {TEST} from '@services/routes';
import {fromJS} from 'immutable';
import {useLingui} from '@lingui/react';

import TestModal from '../TestModal/TestModal';
import SectionComplete from '../FerrariIcon/SectionComplete';

import {setCurrentTest} from '@actions/tests';

import {extractTranslatedLabel} from '@services/utilities';

import cl from 'classnames';
import s from './FerrariTestCard.module.css';

export default function FerrariTestCard(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const {i18n} = useLingui();
  const {tests, lang} = props;

  const [hasClickedReadMore, setHasClickedReadMore] = React.useState(false);

  function startTest(clickedTest) {
    dispatch(setCurrentTest(clickedTest));
    history.push(TEST);
  }

  function enterKeyEvent(event) {
    event.key === 'Enter' ? startTest(tests) : null;
  }

  const description = extractTranslatedLabel(fromJS(tests), lang, 'description');
  const instruction = extractTranslatedLabel(fromJS(tests), lang, 'instructions');
  const testName = extractTranslatedLabel(fromJS(tests), lang, 'name');

  if (tests.status == 'incomplete') {
    return (
      <div
        id="ferrari-section-card-single"
        className={s.FerrariTestCardContainer}
        tabIndex={0}
        onKeyPress={e => enterKeyEvent(e)}
        aria-label="Start test"
      >
        <img className={s.TestCardImg} src={tests.img} alt="" />
        <div className={s.TestInfo}>
          <div className={s.TestNumber}>Test {i18n._('ferrari.incomplete')}</div>
          <div className={s.TestName}> {testName}</div>
          <p className={s.TestDescript}>{description}</p>
          <button
            id="ferrari-section-card-read"
            className={s.ReadMoreButton}
            onClick={() => setHasClickedReadMore(!hasClickedReadMore)}
          >
            {i18n._('ferrari.instructions')}
          </button>
          <TestModal
            isOpen={hasClickedReadMore}
            closeModal={() => setHasClickedReadMore(!hasClickedReadMore)}
            testName={testName}
            startTest={() => startTest(tests)}
            description={description}
            instruction={instruction}
          />
        </div>
        <div
          id="ferrari-section-card-start"
          className={s.TestCardBtn}
          onClick={() => startTest(tests)}
        >
          <div className={s.ButtonText}>{i18n._('ferrari.start')}</div>
        </div>
      </div>
    );
  } else if (tests.status == 'complete') {
    return (
      <div className={s.CompletedTestCardContainer}>
        <img className={s.TestCardImg} src={tests.img} alt="" />
        <div className={s.TestInfo}>
          <div className={s.TestInfoHeader}>
            <div className={s.TestNumber}>Test {i18n._('ferrari.complete')}</div>
          </div>
          <div className={s.TestName}> {testName}</div>
          <p className={s.TestDescript}>{description}</p>
        </div>
        <div className={s.CompletedTestCardBtn}>
          <SectionComplete className={s.ButtonComplete} />
        </div>
      </div>
    );
  } else {
    return (
      <div
        id="ferrari-section-card-single"
        className={cl(s.FerrariTestCardContainer, s.NotAttempted)}
        tabIndex={0}
        onKeyPress={e => enterKeyEvent(e)}
        aria-label="Start test"
      >
        <img className={s.TestCardImg} src={tests.img} alt="" />
        <div className={s.TestInfo}>
          <div className={s.TestNumber}>Test {i18n._('ferrari.not_attempted')}</div>
          <div className={s.TestName}> {testName}</div>
          <p className={s.TestDescript}>{description}</p>

          <button
            id="ferrari-section-card-read"
            className={s.ReadMoreButton}
            onClick={() => setHasClickedReadMore(!hasClickedReadMore)}
          >
            {i18n._('ferrari.instructions')}
          </button>

          <TestModal
            isOpen={hasClickedReadMore}
            closeModal={() => setHasClickedReadMore(!hasClickedReadMore)}
            testName={testName}
            startTest={() => startTest(tests)}
            description={description}
            instruction={instruction}
          />
        </div>
        <div
          id="ferrari-section-card-start"
          className={cl(s.TestCardBtn, s.NotAttempted)}
          onClick={() => startTest(tests)}
        >
          {' '}
          <div className={s.ButtonText}>{i18n._('ferrari.start')}</div>
        </div>
      </div>
    );
  }
}
